import { validationMessage } from 'vuelidate-messages'
import { messages, isDateValid, isDateBeforeMaxDate } from '@/lib/validation-helpers'
import { required, maxLength } from 'vuelidate/lib/validators'

export const validations = {
  validations: {
    formData: {
      name: {
        required,
        maxLength: maxLength(255)
      },
      publisher_id: {
        required
      },
      owner_id: {
        required
      },
      start_date: {
        required,
        isDateValid(val, data) {
          if (!val || !data.start_date || !isDateValid.call(this, data.start_date)) return true
          return isDateValid.call(this, val)
        }
      },
      end_date: {
        isDateValid(val, data) {
          if (!val || !data.start_date || !isDateValid.call(this, data.start_date)) return true
          return isDateValid.call(this, val)
        },
        isDateBeforeMaxDate(val, data) {
          if (!val) return true
          return isDateBeforeMaxDate.call(this, data.start_date, val, `Must be after (${data.start_date})`)
        }
      }
    }
  },

  methods: {
    $v_displayMessage: validationMessage(messages)
  }
}
